module.exports = __webpack_public_path__ + "media/images/front/varieties/CLEMENULES-d134b0c6f6faec8b2d45c24fe0b4e199.jpg";